export default "__VITE_ASSET__27ee3ab5__"